import { Navigate } from "react-router-dom";
import { useAuth } from './AuthProvider'


export default function ProtectedRoute({ children }) {
  const { keycloak } = useAuth();
  console.log("keycloak");
  console.log(keycloak);

  return keycloak.authenticated ? children : <Navigate to="/" />;
}
